import React, { Component } from "react";
import { DropTarget } from "react-dnd";
import { cloneDeep } from "lodash";
import AppItem from "./AppItem";

const groupItemTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        const isOnlyThisOne = monitor.isOver({ shallow: true });
        if (isOnlyThisOne && dragItem.type === "cardList") {
            props.addCardList(dragItem.cardList);
        }
    },
};

//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget("item", groupItemTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
}))
class MyContent extends Component {
    // 删除某一项
    deleteSelf = (i) => {
        let { cardList } = this.props;
        const newCardList = JSON.parse(JSON.stringify(cardList));
        newCardList.splice(i, 1);
        this.props.setList(newCardList);
    };

    //排序 dragIndex: 拖拽元素index targetIndex: 放置元素index 
    moveItem = (dragIndex, targetIndex) => {
        let cardList = cloneDeep(this.props.cardList);
        const dragItem = cardList[dragIndex];
        cardList.splice(dragIndex, 1);
        cardList.splice(targetIndex, 0, dragItem);
        this.props.setList(cardList);
    };

    renderItem = (item, index) => {
        return (
            <div title={item.name} className={`card-item ${item.haspower === false ? 'unauthorized' : ''}`}>
                <AppItem
                    key={item.cardid}
                    item={item}
                    index={index}
                    moveItem={this.moveItem}
                    addCardList={this.props.addCardList}
                />
                <div className="opr-area">
                    <i
                        className="iconfont icon-qingkong card-delete"
                        onClick={() => {
                            this.deleteSelf(index);
                        }}
                    />
                </div>
            </div>
        );
    };
    // 数据列表
    initGroupItem = (cardList) => {
        return cardList.map(this.renderItem);
    };
    render() {
        const { connectDropTarget, cardList } = this.props;
        return connectDropTarget(
            <div className="box-r">
                {cardList.length === 0 ? (
                    null
                ) : (
                    <div className="card-item-content">{this.initGroupItem(cardList)}</div>
                )}
            </div>
        );
    }
}

export default MyContent;
